<template>
  <div class="checkpoint-date">
    <div class="checkpoint-date__date">
      <slot name="date"></slot>
    </div>

    <div class="checkpoint-date__no-matter">
      <slot name="no-matter"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .checkpoint-date {
    display: flex;
    gap: 30px;
    justify-content: space-between;

    &__date {
      flex-grow: 1;
    }
  }
</style>